import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './SectionLinkItem.module.less';

const SectionLinkItem = ({ section, hideSubmenu }) => {
  if (!section.link || hideSubmenu) {
    if (!section.path) return null;
    return (
      <li className={styles.listItem}>
        <a className={styles.text} href={section.path}>
          {section.name}
        </a>
      </li>
    );
  }
  return (
    <li className={styles.listItemList}>
      <a className={classNames(styles.text, styles.arrow)} href={section.path}>
        {section.name}
      </a>
      {section.link && (
        <div className={styles.linkContainer}>
          <div className={styles.navDropdown}>
            {section.link.map(item => (
              <div key={item.category}>
                {item.category && (
                  <p className={styles.categoryLabel}>{item.category}</p>
                )}
                <ul className={styles.sectionMenu}>
                  {item.links &&
                    item.links.map(link => (
                      <li key={link.label}>
                        <a href={link.path} className={styles.contentLink}>
                          {link.label}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </li>
  );
};

SectionLinkItem.propTypes = {
  section: PropTypes.shape({
    name: PropTypes.string,
    path: PropTypes.string,
    link: PropTypes.arrayOf(
      PropTypes.shape({
        category: PropTypes.string,
        links: PropTypes.arrayOf({
          label: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
        }),
      })
    ),
  }).isRequired,
  hideSubmenu: PropTypes.bool.isRequired,
};

export default SectionLinkItem;
